import { apiRequest } from '../../../shared/services/apiClient';
import type { AiPromptUseCaseId } from '../../admin/types/AiPromptConfig';
import type { AiSkillDefinition, UpsertAiSkillRequest } from '../types/Skill';

const normalizeSkill = (value: unknown): AiSkillDefinition => {
  const row = (value ?? {}) as Record<string, unknown>;
  return {
    skillId: String(row.skillId ?? ''),
    name: String(row.name ?? ''),
    description: String(row.description ?? ''),
    body: String(row.body ?? ''),
    isPublished: Boolean(row.isPublished),
    assignedUseCaseIds: Array.isArray(row.assignedUseCaseIds)
      ? row.assignedUseCaseIds.map(String) as AiPromptUseCaseId[]
      : [],
  };
};

export const listAiSkills = async (): Promise<AiSkillDefinition[]> => {
  const result = await apiRequest<unknown[]>('/api/v1/ai/skills', { method: 'GET' });
  return Array.isArray(result) ? result.map(normalizeSkill) : [];
};

export const createAiSkill = async (request: UpsertAiSkillRequest): Promise<AiSkillDefinition> => {
  const result = await apiRequest<unknown>('/api/v1/ai/skills', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });
  return normalizeSkill(result);
};

export const updateAiSkill = async (
  skillId: string,
  request: UpsertAiSkillRequest,
): Promise<AiSkillDefinition> => {
  const result = await apiRequest<unknown>(
    `/api/v1/ai/skills/${encodeURIComponent(skillId)}`,
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(request),
    },
  );
  return normalizeSkill(result);
};

export const deleteAiSkill = async (skillId: string): Promise<void> => {
  await apiRequest<void>(`/api/v1/ai/skills/${encodeURIComponent(skillId)}`, { method: 'DELETE' });
};
